import CardPageLayout from '@upheal/shared/components/shared/LayoutContainers/CardPageLayout';
import { Typography } from '@mui/material';

const WhiteLabelFallbackPage = () => {
    return (
        <CardPageLayout
            colorTheme="dark"
            showLogo={false}
            showFooter={false}
            cardSx={{ maxWidth: 450 }}
        >
            <Typography textAlign="center">
                You can join this session from your portal.
            </Typography>
        </CardPageLayout>
    );
};

export default WhiteLabelFallbackPage;
